import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const TANDA_TURN_TOUR_ID = 'tanda-turn';

export const tandaTurnSteps: StepType[] = [
  {
    selector: '[data-tour="tandas-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="celebrating" size="sm" direction="right" showPointer={false}>
        Toca tu tanda activa para ver tu <strong>número de turno</strong>, la fecha estimada de
        cobro y el historial de pagos.
      </MascotBubble>
    ),
  },
];
